import type { ApplicantCreation } from 'cpool-schemas';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormNumberInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormNumberInput';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';

export const Haushalt: React.FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext<ApplicantCreation>();

    return (
        <FormCard title={t('LIVING_SITUATION_DATA.HAUSHALT.TITLE')}>
            <FormNumberInput
                id="wohnsituation.anzahlPkw"
                label={t('LIVING_SITUATION_DATA.HAUSHALT.NUMBER_OF_PRIVATE_CARS')}
                control={control}
                min={0}
                allowDecimals={false}
            />
        </FormCard>
    );
};
